import { render, staticRenderFns } from "./UserPraQuesDetail.vue?vue&type=template&id=0c891348"
import script from "./UserPraQuesDetail.vue?vue&type=script&lang=js"
export * from "./UserPraQuesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports